import { render, staticRenderFns } from "./adminShopVip.vue?vue&type=template&id=ff3ebf00&scoped=true"
import script from "./adminShopVip.vue?vue&type=script&lang=js"
export * from "./adminShopVip.vue?vue&type=script&lang=js"
import style0 from "./adminShopVip.vue?vue&type=style&index=0&id=ff3ebf00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3ebf00",
  null
  
)

export default component.exports